import React from 'react';

import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { createFormActionElement } from '../../../data/store/onboarding/onboardingActions';

const OnboardingActionItemFabrica = ({formItem, onboardingId}) => {
  const dispatch = useDispatch();

  const data = formItem?.form_action_element;

  const handleAction = () => {
    const config = {
      'form_action_element_id': data?.id,
      'form_submission_id': onboardingId
    };
    dispatch(createFormActionElement(config));
  };
  return (
    <div className='onboarding-action-item-fabrica'>
      <Button
        type="text"
        onClick={() => handleAction()}
        className="onboarding-upload-btn">
        {data?.description}
      </Button>
      <p className='onboarding-action-item-hint'>{data?.hint}</p>
    </div>
  );
};

export default OnboardingActionItemFabrica;

OnboardingActionItemFabrica.propTypes = {
  formItem: PropTypes.object.isRequired,
  onboardingId: PropTypes.string.isRequired,
};